import { User } from '@sec-loans-ui/wizard/types'
import { LoanOfferItem } from '@shared/sec-loans'
import { createContext, use } from 'react'

import { FormContextValue } from '../types'
import { WizardStep } from '../wizard/wizardMachine'

export const FormContext = createContext<FormContextValue>({
  step: WizardStep.StatusStep,
  exit: () => Promise.resolve(),
  exitWithConfirmDialog: () => null,
  goBack: () => null,
  proceed: () => null,
  goBackToStatus: () => null,
  loanOffer: {} as LoanOfferItem,
  user: {} as User,
})

export const useLoanOfferFormContext = () => {
  const context = use(FormContext)
  if (context === undefined) {
    throw new Error('useLoanOfferFormContext must be used within a FormContext')
  }
  return context
}
